var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRf4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_655",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_655",
    transform: "scale(0.0208333 0.025641)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_655",
    width: 48,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAnCAQAAADj2AMvAAAD8klEQVRIx9WXfWjVVRjHf/N+zuU6vBJzpPmHpSg6TOgNpiJioIW9sMwXEltmRCmJExQl8l2X2XBzGUn5EqRONJxaRMWK2QuT2xza8hW3VUopm+WyfKHcbt97t9V9OefuXtg/nofxO3uec57vOef5Ps851/McjZFc4ke+YUk4y+vp5ruLPTQQJsQJ2tnRw+4DhiP8xacCWBsMsJ+/mZ56Bvk8Yhe/3zZ8nlwvZ1QEwPNMLpepYankMSfAUY21yyjb8De4xfAuAP3/S+fgs06AEMd5NUlqXQAvy7C6C4D+/CYHqyTPpAD4wqL9xAEQhDquUxUBCGRzkJtM6yYGmQEwjT+15VMyH+UMbbzbHS0yAjBB6mlkkA4pzDmqKeqedxkBsJ1/mCeq/kBdf196xM4AwAznCgdlnCPjqnQzJwMAtnCDifpWcJW7exzA34efqfK8cBanqba6GsCDFqlLE4DnpVqsg7pHNN1kBdjryNhf+TZOQvq7kAzwDtfMEH1nyLTEClCr2rSGdaxnAyWUapU/US7GxUs1raL4aooDd8RP/5ra6LdQAAuS3asu/WGmxGrye7FWfJsd52WWcv97htrWd5b9UUeTBLDCYp9Dq8lN0k5X3pR13RpK02ZOmjx7mb7E9kgvu7fOdK8FoJyQ9eBGa2kVQdR7govq32clmxmo0JZ2TvlQ+fBAQo0KiC1bHESdqFhU6Aa4QKPJd7DZDFaZ3tA5YQwtqkbj/reKujtU9iY4c6FQFaxZNB/vTJcowFYe7jhlCjS4mQO8RhGviDnfqeztTJlumztI7jLfqy22RzndRhO7TJ5O9mN+/4/pTbye3TsVgCJXT6XVJLJtlqtW0XQTK3iTj9RvoTyc5c9hKvOZayb5+6RRMop0l4+2uX9faz/suz/muEZo9e1s9TJq4uFp9iTjFusAdkdIFtsU1ErafGsyg1AMzwcD8aHtp+dVyHa6Kn01svXNCGA+YfN0vKpE63e8e3hSl0+ZyUtfmClvy+KdHKIpYJwrOu588bjl7XgXxzgpDrmkXuWjOEkalYTFFjkg9/sSnjdKp+tSX7VKWLbzln0d44h1vws1Y3ZiKHOiLHrR5CYKL0hf5s+xOPqSU/m9LPoSJelDSWrfWN3D2yzDt3HTjLOutFTQzyaxzq+b4YQN2OMz5fHkBN2jujY+d4R+qB73NYm5rXrVznrXhHOq4jF3FU/pTdfIMCe7FonAVb6BMZp1XOOrQLZrQoEgbih3V/KSnrmV6jf4pqRMqY3a4UXeYzFzeUt39S39GhqWasKdfKAC18HkFnYxoNusLeBwlIERaWBjGuVQjCoU1Z6zMccBMlI7XsDj7lS9/du/PwupT7rvtvAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf4);
export default __webpack_public_path__ + "static/media/rf4.18e7cfadaa40f3a5657c7384d6d7dbd9.svg";
export { ForwardRef as ReactComponent };